export default __webpack_public_path__ + "static/media/information-button.3b2d2dc5.svg";